import React from 'react';

import { SerialNumber, UUID } from 'src/types/utility';
import PatientAssigner from '../PatientAssigner';
import PatientSettings from '../PatientSettings';
import PatientStatusComponent from 'src/components/PatientStatusComponent';
import {
  DeviceAlerts,
  NurseStationDevice,
} from 'src/routes/NursesStation/modules/types';
import { deepEqual } from 'src/utils/comparators';

type Props = {
  hasAssignedPatient: boolean;
  patientId: UUID;
  deviceId: SerialNumber;
  isDeviceConnected: boolean;
  isUnoccupied: boolean;
  ongoingDeviceAlerts: DeviceAlerts;
  hasVacancyNotificationEnabled: boolean;
  isLongOutOfBedAlertActive: boolean;
  isPositionChangeAlertActive: boolean;
};
type LocationProps = Pick<NurseStationDevice, 'roomName' | 'bedName'>;
const DevicePatient = ({
  hasAssignedPatient,
  patientId,
  deviceId,
  isDeviceConnected,
  isUnoccupied,
  ongoingDeviceAlerts,
  hasVacancyNotificationEnabled,
  isLongOutOfBedAlertActive = false,
  isPositionChangeAlertActive = false,
  bedName,
  roomName,
}: Props & LocationProps): JSX.Element | null => {
  if (!isDeviceConnected) {
    return null;
  }

  if (hasAssignedPatient) {
    return (
      <PatientSettings
        bedName={bedName}
        roomName={roomName}
        patientId={patientId}
      >
        <PatientStatusComponent
          isUnoccupied={isUnoccupied}
          isDeviceConnected={isDeviceConnected}
          isVacancyAlertActive={hasVacancyNotificationEnabled}
          isLongOutOfBedAlertActive={isLongOutOfBedAlertActive}
          isPositionChangeAlertActive={isPositionChangeAlertActive}
          ongoingDeviceAlerts={ongoingDeviceAlerts}
        />
      </PatientSettings>
    );
  }

  return <PatientAssigner deviceId={deviceId} />;
};

export default React.memo(DevicePatient, (oldProps, newProps) =>
  deepEqual(oldProps, newProps),
);
